/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
import { IDate, IFields, ISlotTime } from '../../../interfaces';
import LayoutInside from '../../layout/LayoutInside';
import Button from '../../sections/Button';
import SliderDate from '../../sections/SliderDate';
import SlotTime from '../../sections/SlotTime';
import Field from './Field';
import { useHistory, useLocation } from 'react-router-dom';
import { dateList } from '../../../../common/data/dateList';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClubById, fetchClubBySlot, resetStateClubSlot } from '../../../../modules/sport/actions/reducerClub';
import Loading from '../../../loading/Loading';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function RentFields(props): JSX.Element {
    const { attribute } = props;
    const dispatch = useDispatch();
    const [selectedField, setSelectedField] = useState('0');
    const [selectedSlot, setSelectedSlot] = useState();
    const [select, setSelect] = useState<IDate>(dateList().find((i) => i.active === true));
    const [field, setField] = useState<IFields>();
    const [fields, setFields] = useState<Array<IFields>>([]);
    const [nameClub, setNameClub] = useState<string>('');
    const [title, setTitle] = useState<string>('');
    const [slot, setSlot] = useState<ISlotTime>();
    const [loadingSlot, setLoadingSlot] = useState<boolean>(false);
    const [slots, setSlots] = useState<ISlotTime[]>([]);
    const router = useHistory();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const query = useQuery();
    const club = query.get('club');
    //const day = query.get('day');
    const region = query.get('region');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const attributeUrl = pathname.length > 1 ? pathname[2] : 'arrienda';
    const clubId = club;
    const [activeNotFound, setActiveNotFound] = useState<string>('inactive');
    const pathnameClubs = `/${sport}/arrienda/clubes/filter` + useLocation().search;

    const inputRefButton = useRef<HTMLDivElement>();
    const inputRefFields = useRef<HTMLDivElement>();
    const inputRefSlot = useRef<HTMLDivElement>();

    const pathnameAll = window.location.pathname + useLocation().search;

    const breads = [
        {
            key: 'sport',
            name: 'Arrienda',
            url: `/arrienda`,
            add: true,
        },
        {
            key: 'clubes',
            name: 'Clubes',
            url: pathnameClubs,
            add: false,
        },
        {
            key: 'reservar',
            name: 'reservar',
            url: pathnameAll,
            add: false,
        },
    ];
    const selectClub = (state: any) => state.club;
    const clubActive = useSelector(selectClub);

    const selectClubSlot = (state: any) => state.clubSlot;
    const clubSlot = useSelector(selectClubSlot);

    useEffect(() => {
        const fetchClub = async () => {
            setNameClub(clubActive.data.data.name);
            setTitle(clubActive.data.data.name);
        };
        if (clubActive && clubActive.data && clubActive.data.data) {
            fetchClub();
        }
    }, [clubActive]);

    useEffect(() => {
        const fetchClubSlot = async () => {
            //aqui mapear los slot y los clubs
            if (clubSlot.data.data.slots && clubSlot.data.data.slots.length > 0) {
                const slotMap = clubSlot.data.data.slots.map((item) => {
                    const available = item.fields.filter((s) => s.available === true);
                    return { ...item, available: available.length > 0 };
                });
                //console.log({ slotMap });
                setSlots(slotMap);
            }
        };
        if (clubSlot && clubSlot.data && clubSlot.data.data) {
            fetchClubSlot();
            //console.log({ clubSlot });
        }
        setLoadingSlot(clubSlot.isLoading);
    }, [clubSlot]);

    useEffect(() => {
        if (clubId) {
            dispatch(fetchClubById(clubId));
            //aqui limpiar el estado nuevo clubSlot
        }
    }, [clubId]);

    useEffect(() => {
        setSelectedSlot(null);
        setSlot(null);
        setSelectedField('0');
        setFields([]);
        setSlots([]);
        setActiveNotFound('inactive');
        dispatch(resetStateClubSlot());
        if (select && select.date && clubId) {
            // console.log('aqui selecciono fecha voy a scrollHandlerSlot');

            scrollHandlerSlot();
            dispatch(fetchClubBySlot({ sport: sport, clubId, date: select.dateFormat }));
        }
    }, [select]);

    useEffect(() => {
        if (selectedField) {
            if (fields && fields.length > 0) {
                //  console.log('aqui selecciono cancha voy a scrollHandlerButton:');
                scrollHandlerButton();
                setField(fields.find((i) => i.id === selectedField));
            }
        }
    }, [selectedField]);

    useEffect(() => {
        setSelectedField('0');
        setFields([]);

        if (slots && slots.length > 0) {
            const slotDetail = slots.find((i) => String(i.id) == String(selectedSlot));
            if (slotDetail) {
                setSlot(slotDetail);
                setFields(
                    slotDetail.fields.sort(function (a, b) {
                        if (a.name > b.name) {
                            return 1;
                        }
                        if (a.name < b.name) {
                            return -1;
                        }
                        // a must be equal to b
                        return 0;
                    }),
                );
                // console.log('aqui selecciono slot voy a scrollHandlerField');
                scrollHandlerField();
            }
        }
    }, [selectedSlot]);

    useEffect(() => {
        const titleAll = `${nameClub}`;
        setTitle(titleAll);
    }, [select, slot, field, nameClub]);

    const handlerNext = (e: React.SyntheticEvent) => {
        e.preventDefault();
        //  console.log({ field });
        const path = `/${sport}/${attributeUrl}/pago/filter`;
        const date = `${select?.date}/${select?.year}`;
        const start = slot?.start && slot?.start;
        const end = slot?.end && slot?.end;
        const dateEnd = `${select.dateFormat} ${end}`;
        const dateStart = `${select.dateFormat} ${start}`;
        const search = `?field=${selectedField ? selectedField : ''}&fieldName=${field?.name ? field.name : ''}&price=${
            field?.prices && field?.prices.length > 0 ? field?.prices.map((p) => p.id).join(',') : ''
        }&slot=${selectedSlot ? selectedSlot : ''}&start=${start ? start : ''}&end=${end ? end : ''}&date=${
            date ? date : ''
        }&dateStart=${dateStart ? dateStart : ''}&dateEnd=${dateEnd ? dateEnd : ''}&fieldId=${
            field?.id ? field?.id : ''
        }&priceOnly=${field?.price ? field?.price : ''}&day=${select && select.id ? select.id : ''}&club=${
            club ? club : ''
        }&region=${region}&nameClub=${nameClub}&address=${field?.address ? field.address : ''}`;
        router.push({
            pathname: path,
            search: search,
        });
    };

    const scrollHandlerButton = () => {
        if (selectedField !== '0' && selectedSlot && inputRefButton.current) {
            setTimeout(function () {
                //const coordinates = inputRefButton.current.getBoundingClientRect();
                // const coordinatesField = inputRefFields.current.getBoundingClientRect();
                //scrollToGo(coordinates.x, coordinates.y + coordinatesField.height);
                //console.log({ coordinates }, coordinates.y + coordinatesField.height);
                //window.scrollTo({ top: coordinates.y + coordinatesField.height, behavior: 'smooth' });
            }, 300);
        }
    };

    const scrollHandlerField = () => {
        if (inputRefFields.current) {
            setTimeout(function () {
                const coordinates = inputRefFields.current.getBoundingClientRect();
                console.log({ coordinates });
                //scrollToGo(coordinates.x, coordinates.y);
            }, 300);
        }
    };

    const scrollHandlerSlot = () => {
        if (!loadingSlot && select && slots && slots.length > 0 && inputRefSlot.current) {
            setTimeout(function () {
                //const coordinates = inputRefSlot.current.getBoundingClientRect();
                //console.log({ coordinates });
                //window.scrollTo({ top: coordinates.top, behavior: 'smooth' });
            }, 300);
        }
    };

    /*const scrollToGo = (x, y) => {
        console.log({ x, y });
        //window.scrollTo(x, y);
    };*/

    return (
        <LayoutInside
            attribute={attribute}
            title={!select ? 'Selecciona una Fecha' : !selectedSlot ? 'Selecciona una Hora' : 'Selecciona una cancha'}
            subTitle={title}
            breads={breads}
        >
            {clubActive.isLoading ? (
                <Loading />
            ) : (
                <>
                    <div className={`flex-col py-2`} role="RESERVAR">
                        <div className="container mx-auto w-full md:flex lg:flex  justify-center items-center  md:px-20 lg:px-20">
                            <div className="md:w-11/12 lg:w-11/12">
                                <SliderDate attribute={attribute} select={select} setSelect={setSelect} />
                                <div
                                    className={`grid w-full grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 text-center justify-center`}
                                >
                                    <div className=" md:px-6 lg:px-6 ml-4 md:ml-24 lg:ml-24 md:mr-10 lg:mr-0">
                                        {!loadingSlot && select && slots && slots.length > 0 && (
                                            <div>
                                                <div ref={inputRefSlot}>
                                                    <p className="text-2xl text-sm-rent text-left pl-2 my-2">
                                                        Selecciona tu Horario
                                                    </p>
                                                </div>
                                                <SlotTime
                                                    slots={slots}
                                                    selectedSlot={selectedSlot}
                                                    setSelectedSlot={setSelectedSlot}
                                                ></SlotTime>
                                            </div>
                                        )}

                                        {activeNotFound === 'active' && (
                                            <div className="border border-red-600 shadow rounded-xl p-4 max-w-sm w-full mx-auto">
                                                <div className="text-base text-red-500">
                                                    No hay horarios disponibles en el {nameClub} para este dia{' '}
                                                    {select?.day} {select?.date}
                                                </div>
                                            </div>
                                        )}
                                        {select && loadingSlot && (
                                            <div className="border border-sm-rent shadow rounded-xl p-4 max-w-sm w-full mx-auto">
                                                <div className="animate-pulse flex space-x-4">
                                                    <div className="rounded-full bg-sm-rent-dark h-6 w-12"></div>
                                                    <p className="pl-1 animate-pulse text-sm-rent-dark">Buscando</p>
                                                    <div className="flex-1 space-y-4 py-1">
                                                        <div className="h-4 bg-sm-rent-dark rounded w-3/4"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>{' '}
                                    <div className="flex-col snap-mandatory snap-y md:px-6 lg:px-6 ml-4 md:ml-4 lg:ml-4 md:mr-10 lg:mr-0">
                                        <div ref={inputRefFields}>
                                            {' '}
                                            {slot && selectedSlot && select && fields.length > 0 && (
                                                <p className="text-2xl text-sm-rent text-left pl-2 my-2">
                                                    Selecciona tu Cancha
                                                </p>
                                            )}{' '}
                                        </div>

                                        {slot &&
                                            selectedSlot &&
                                            select &&
                                            fields.length > 0 &&
                                            fields.map((field, index) => (
                                                <Field
                                                    key={`${field.id + index}`}
                                                    field={field}
                                                    handleSelectedField={setSelectedField}
                                                    selectedField={selectedField}
                                                    sport={sport}
                                                />
                                            ))}

                                        {selectedField !== '0' && selectedSlot && (
                                            <div
                                                ref={inputRefButton}
                                                className="flex flex-col mx-auto w-1/2 md:w-full  mt-12 mb-12 snap-center "
                                            >
                                                <Button title={'CONTINUAR'} handlerClick={handlerNext} />
                                            </div>
                                        )}

                                        {/*loadig && (
                                            <div className="border border-sm-rent shadow rounded-xl p-4 max-w-sm w-full mx-auto">
                                                <div className="animate-pulse flex space-x-4">
                                                    <div className="rounded-full bg-sm-rent-dark h-6 w-12"></div>
                                                    <p className="pl-1 animate-pulse text-sm-rent-dark">Buscando</p>
                                                    <div className="flex-1 space-y-4 py-1">
                                                        <div className="h-4 bg-sm-rent-dark rounded w-3/4"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        )*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </LayoutInside>
    );
}
